import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Modal } from 'semantic-ui-react';
const FontAwesome = require('react-fontawesome');

interface Error {
    exception: any;
    info: any;
}

class State {
    mounted: boolean;
    error?: Error;
    external?: boolean;
}

interface Props {
    closeWindowPortal ?: () => void;
    title ?: any;
    active?: boolean;
    size?: 'small'|'large'|'fullscreen';
}

export default class PortalView extends React.Component<Props, State> {
    containerEl: any;
    externalWindow: any;

    constructor(props: any) {
        super(props);
        this.externalWindow = null;
        this.state = {
            mounted: false,
            external: false
        };
        this.close = this.close.bind(this);
        this.popExternal = this.popExternal.bind(this);
    }

    componentWillUnmount() {
        this.close();
    }

    componentWillReceiveProps(nextProps: Props) {
        if (this.props.active !== nextProps.active) {
            if (nextProps.active && !this.state.mounted) {
                // activate window
                // console.log("props => activate()");
                if (this.state.external) {
                    // console.log("props => popExternal()");
                    this.popExternal();
                } else {// SAN-2942: No longer popModal for Edge Browser (EOL 01/20).
                    this.popExternal();
                }
            } else if (this.state.mounted) {
                // console.log("props => close()");
                // close window
                this.close();
            }
        }
    }

    componentDidCatch(error: any, info: any) {
        // tslint:disable-next-line:no-console
        console.log('error ', error, info);
        this.setState({ error: {
            exception: error,
            info
        }});
    }

    popModal() {
        // for now we just need to set the mounted state to activate
        this.setState({ mounted: true });
    }

    popExternal() {
        // If existing modal is open, no worries, it will automatically close when the external state is set
        let width = 1300;
        let height = 900;
        let top = window.innerHeight - height;
        let left = window.innerHeight - width;

        // console.log("activating external window");

        // SAN-2838, SAN-2856 Edge browser is slow AF and can crash main UI when creating external windows controlled
        // through a parent DOM. This means we should be popping external windows by using a URL link where the link page
        // generates its own content.
        this.externalWindow = window.open(
            '',
            '', // scrollbars=yes or scrollbars=1 did not work for Media Files View.
            'location=no,toolbar=no,menubar=no,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left,
        );
        this.externalWindow.document.title = (this.props.title) ? this.props.title : '';

        // SAN-2835 Edge browser requires we create elements on the external document DOM not our parent
        // otherwise Edge will produce errors and the main UI will go blank
        this.containerEl = this.externalWindow.document.createElement('div');

        // must copy CSS styles from main window to popup.
        // Webpack embeds all CSS links into embedded CSS, so we end up copying actual css text. We could change webpack
        // to embed links which might help Edge browsers.
        this.copyStyles(document, this.externalWindow.document);

        this.externalWindow.document.body.appendChild(this.containerEl);

        // bind the close button event to initiate closing of window resources
        // SAN-2856 Once this event completes the window is destroyed and Edge browsers will produce 'Permission denied ...[object]"
        // errors under some race conditions. Possibly events from React's commit list are causing these race conditions.
        // React needs to complete events before window is actually closed.
        this.externalWindow.addEventListener('beforeunload', () => {
            // user clicked the [X] button to close the window
            // console.log("closing portal");
            this.close();
            /*this.externalWindow.document.body.removeChild(this.containerEl);
            this.setState({ mounted: false }, () => {
                if (this.props.closeWindowPortal)
                    this.props.closeWindowPortal();
            });*/
        });

        this.setState(() => ({ mounted: true, external: true }) );
    }

    close() {
        const { external, mounted } = this.state;
        if (mounted) {
            // notify parent we are closing
            if (this.props.closeWindowPortal)
                this.props.closeWindowPortal();

            if (this.state.mounted && this.externalWindow) {    // we check again because the closeWindowPortal() event might change this
                if (external) {
                    // console.log("closing external window");
                    this.externalWindow.document.body.removeChild(this.containerEl);
                    this.externalWindow.close();
                    this.externalWindow = undefined;
                    this.containerEl = undefined;
                } else {
                    // console.log("closing modal window", mounted);
                }
            }
            this.setState({ mounted: false, external: false });
        }
    }

    render() {
        const { mounted, external, error } = this.state;
        const { active, size, children } = this.props;
        if (error) {
            return null;

            /* trying to output this will target the root doc, not the portal window
            const error = this.state.error;
            return (
                <div className="error">
                    <h2>{error.exception.description}</h2>
                    <p>{error.exception.stack}</p>
                </div>
            );*/
        }
        if (active && mounted) {
            if (external) {
                return this.containerEl
                    ? ReactDOM.createPortal(children, this.containerEl)
                    : null;
            } else {
                return (
                    <Modal
                        open={true}
                        dimmer="blurring"
                        size={size}
                        onClose={this.close}
                        className="portal-view"
                    >
                        <div className="modal-icons">
                            <FontAwesome name="external-link" onClick={this.popExternal} />
                            <FontAwesome name="times" onClick={this.close} />
                        </div>
                        {children}
                    </Modal>
                );
            }
        } else
            return null;
    }

    copyStyles(sourceDoc: any, targetDoc: any) {
        // collect all css rules into a single array
        let cssrules: string[] = [];

        Array.from(sourceDoc.styleSheets).forEach((styleSheet: any) => {

            if (styleSheet.cssRules) {
                // true for inline styles

                // gather all css rules as text
                Array.from(styleSheet.cssRules)
                    .forEach( (css: any) => cssrules.push( css.cssText ) );
            } else if (styleSheet.href) {
                // true for stylesheets loaded from a URL
                const newLinkEl = targetDoc.createElement('link');

                newLinkEl.rel = 'stylesheet';
                newLinkEl.href = styleSheet.href;
                targetDoc.head.appendChild(newLinkEl);
            }
        });

        // add styles as a single text string
        // SAN-2838 MS Edge browser is a retard and slow AF create/inserting nodes into DOM (even DocFragments) so
        // we collect all CSS rules and add only once.
        const newStyleEl = targetDoc.createElement('style');
        newStyleEl.appendChild( targetDoc.createTextNode(cssrules.join('')) );
        targetDoc.head.appendChild(newStyleEl);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/portal.tsx